import sizesCodeList from '../../../integrator-app/src/integrate/integrate-parameter-data-sizes';
export default sizesCodeList;
